import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ANIMAL_TYPES, COLORS } from '../lib/constants'

interface Props {
  open: boolean
  onClose: () => void
}

export function ChipSearchModal({ open, onClose }: Props) {
  const { t } = useTranslation()
  const [q, setQ] = useState('')
  const [type, setType] = useState('')
  const [color, setColor] = useState('')
  const [chip, setChip] = useState('')
  const [resultNote, setResultNote] = useState<string | null>(null)

  if (!open) return null

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="animal-search-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="animal-search-title">{t('forms.searchTitle')}</h2>
        <form
          className="form-grid"
          onSubmit={async (e) => {
            e.preventDefault()
            try {
              const params = new URLSearchParams()
              if (q.trim()) params.set('q', q.trim())
              if (type) params.set('type', type)
              if (color) params.set('color', color)
              if (chip.trim()) params.set('chip', chip.trim())
              const res = await fetch(`/api/search?${params}`)
              if (!res.ok) {
                setResultNote(t('forms.noResults'))
                return
              }
              const data = (await res.json()) as {
                results: unknown[]
              }
              const total = data.results?.length ?? 0
              setResultNote(total ? `${total} hit(s)` : t('forms.noResults'))
            } catch {
              setResultNote(t('status.error'))
            }
          }}
        >
          <div className="field">
            <label htmlFor="search-q">{t('fields.searchTerms')}</label>
            <input
              id="search-q"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder={t('forms.searchPlaceholder')}
              autoFocus
            />
          </div>
          <div className="search-filter-grid">
            <div className="field">
              <label htmlFor="search-type">{t('fields.type')}</label>
              <select id="search-type" value={type} onChange={(e) => setType(e.target.value)}>
                <option value="">{t('fields.any')}</option>
                {ANIMAL_TYPES.map((key) => (
                  <option key={key} value={key}>
                    {t(`types.${key}`)}
                  </option>
                ))}
              </select>
            </div>
            <div className="field">
              <label htmlFor="search-color">{t('fields.color')}</label>
              <select id="search-color" value={color} onChange={(e) => setColor(e.target.value)}>
                <option value="">{t('fields.any')}</option>
                {COLORS.map((key) => (
                  <option key={key} value={key}>
                    {t(`colors.${key}`)}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="field">
            <label htmlFor="search-chip">{t('fields.chip')}</label>
            <input
              id="search-chip"
              value={chip}
              onChange={(e) => setChip(e.target.value.replace(/\D/g, '').slice(0, 15))}
              inputMode="numeric"
              placeholder={t('forms.chipPlaceholder')}
            />
          </div>
          {resultNote && <p className="empty-state">{resultNote}</p>}
          <div className="form-actions">
            <button type="button" className="btn" onClick={onClose}>
              {t('actions.cancel')}
            </button>
            <button type="submit" className="btn btn-primary">
              {t('actions.search')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
